<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { usePayoutStore } from '@/store/payoutStore';
import { useAgentStore } from "@/store/agentStore";


import moment from 'moment';

import Swal from "sweetalert2";


import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
    const payoutStore = usePayoutStore();
    const agentStore = useAgentStore();



        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          payoutStore,
          agentStore,


        };
    },
    page: {
    title: "Payouts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "payouts",
      items: [
        {
          text: "Menu",
        },
        {
          text: "payout",
          active: true,
        },

      ],
      errors: [],
      payouts: [],
      transfer_search: [],
      state: "",
      states: [{
        "key": "TOUT"
      }, {
        "key": "EN ATTENTE"
      }, {
        "key": "PROUVEE"
      }, {
        "key": "EN COURS"
      }, {
        "key": "TRANSFERER"
      }, {
        "key": "TERMEINE"
      }, {
        "key": "ECHOUE"
      }],
      search: '',
      loading: false,
      status: 201,
      page: 1,
      agents: [],
      perPage: 10,
      length: 0,
    };
  },
  methods: {
   



       
  async loadFromStore() {

      if (!this.payoutStore.list) {
       await  this.payoutStore.loadFromApi(true).then(data => {
          this.payouts = data
          this.payout_search = data;
          this.length = this.payouts.length;
        })
      } else {
        this.payouts = this.payoutStore.list
        this.payout_search = this.payouts;
        this.length = this.payouts.length;
      }
  },

  async refresh(){
    await  this.payoutStore.loadFromApi(true).then(data => {
      this.payouts = data
      this.payout_search = data;
      this.length = this.payouts.length;
    })
    },

    async loadAgents() {
      if (!this.agentStore.list) {
        await this.agentStore.loadFromApi().then((data) => {
          this.agents = data;
        });
      } else {
        this.agents = this.agentStore.list;
      }
    },

  





    show(index) {
        return (index < this.page * this.perPage && (index + 1) > (this.page - 1) * this.perPage)
    },
    next() {
        if ((this.page * this.perPage) < this.payouts.length) {
            this.page++
        }
    },
    previous() {
        if (this.page >= 2) {
            this.page--
        }
    },
    filter_transfer() {
      this.payouts = this.transfer_search
      if (this.search != "") {
        this.payouts = this.payouts.filter(payout => (
           payout.idOfTransfer?.includes(this.search) ||
          payout.idOfAgent?.includes(this.search) ||
          payout.payId?.includes(this.search) ||
          payout.provenAt?.includes(this.search) ||
          payout.tookAt?.includes(this.search) ||
          payout.confirmedAt?.includes(this.search) ||
          payout.cancelledAt?.includes(this.search) 
         ))
      }
    },
    convertDate(date) {
      return moment.utc(date).format('DD-MM-YY') + " " + moment.utc(date).format('HH:mm')
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          }
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
      
    },

     getExtension(file) {
      return file.proof?.split(".")?.pop()?.toLowerCase();
    },
    isImage(file) {
      const extensions = ["jpg", "jpeg", "png", "gif"];
      return extensions.includes(this.getExtension(file));
    },
    isPDF(file) {
      return this.getExtension(file) === "pdf";
    },
   
  
     truncateEmail(email) {
      if (email.length > 15) {
        return email.slice(0, 13) + '...'; // Récupère les 17 premiers caractères et ajoute "..."
      }
      return email; // Retourne l'email tel quel si sa longueur est inférieure ou égale à 20
    },
    getPayoutStatus(payout) {
      if (payout.cancelledAt) return "cancelled";
      if (payout.provenAt) return "proven";
      if (payout.tookAt) return "processing";
       return "pending";
    },

    getPayoutDate(payout) {
      return payout.cancelledAt ?? payout.provenAt ?? payout.tookAt ?? payout.createdAt;
    },
    getAgentInfo(payout) {
      if (!payout.idOfAgent) {
        return '';
      }
      const agent = this.agentStore.getOne(payout.idOfAgent);
      if (agent?.user) {
        return `${agent.user.lastName} ${agent.user.firstName}`
      } else {
        return payout.idOfAgent;
      }
    },
  },
  mounted() {
    this.loadFromStore();
    this.loadAgents();
    this.doesLoadingOpen = false
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">

      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>

    </div>

    <div class=" row mb-3" v-show="status != 403">
      <div class="col-6  col-md-4 ">
        <input type="search" class="form-control" v-model="search" v-on:input="filter_transfer()"
          placeholder="Rechercher une transfer">
      </div>

      <div class="col-4 col-sm-2 ms-auto ms-md-3">
        <select name="" id="" v-model="state" class="form-control text-center bg-secondary text-white">
          <option value="">Statut</option>
          <option v-for="state in states" :key="state.key" :value="state.key">{{ state.key }}</option>
        </select>
      </div>

      <div class=" col-5 col-sm-2 ms-0 ms-md-3 mt-3 mt-md-0">
        <select v-model="perPage" class="form-control text-center">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
        </select>
      </div>

      <div class="ms-auto   col-6 col-sm-2 ps-5  mt-4 mt-md-0 ms-md-3">
        <i class="bx bx-left-arrow-alt p-2 fs-5 fs-sm-1" type="button" @click="previous"></i>

        <small class="ms-3 ">
          {{ Math.ceil(payouts.length / perPage) > 0 ? page : 0 }} /
          {{ Math.ceil(payouts.length / perPage) }}
        </small>

        <i class="bx bx-right-arrow-alt fs-5 fs-sm-1 p-2 ms-3 " type="button" @click="next"></i>
      </div>


    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des transfers</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>transfers</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead class="bg-light rounded">
                  <tr>
                    <th>#</th>
                    <th>Transfer</th>
                    <th>agent</th>
                    <th>payId</th>
                    <th>proof</th>
                    <th>Status</th>
                    <th>Account</th>
                    <th>Wallet</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in payouts" v-show="show(i)" :key="item.id">
                    <th scope="row" v-on:click="compileToClipboard(item.id)" style="cursor: pointer;">{{ i + 1 }}</th>
                    <td>{{ item.idOfTransfer }}</td>
                    <td>{{ getAgentInfo(item) }}</td>
                    <td>{{ item.payId }}</td>
                    <td>
                      <a v-if="item?.proof" :href="item?.proof" target="_blank">
                        <div v-if="isImage(item)">
                          <img :src="item.proof" alt="Aperçu image" style="width: 50px; height: auto;" />
                        </div>
                        <div v-else-if="isPDF(item)">
                          <i class="fas fa-payout-pdf" style="color: red;"></i> PDF
                        </div>
                        <div v-else>
                          <i class="fas fa-payout-alt"></i> {{ getExtension(item) }}
                        </div>
                      </a>

                    </td>
                    <td>{{ getPayoutStatus(item) }}</td>
                    <td>{{ item.account?.number ?? item.idOfAccount }}</td>
                    <td>{{ item.wallet?.number ?? item.idOfWallet ?? '' }}</td>

                    <td>{{ convertDate(getPayoutDate(item)) }}</td>
                    <td>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
      </div>
    </div>


    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Vous n'êtes pas encore ajouté, demandez à l'administrateur principal.
      </h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..." title-class="font-18"
      hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>
